import type { TeactNode } from '../../lib/teact/teact';
import React, { memo, useState } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';
import { vibrate } from '../../util/haptics';

import styles from './PinPad.module.scss';

interface OwnProps {
  value?: any;
  children?: TeactNode;
  className?: string;
  isDisabled?: boolean;
  isPasscodeScreen?: boolean;
  secondaryLabel?: string;
  ariaLabel?: string;
  onClick?: (value?: any) => void;
}

const CLICKED_TIMEOUT_MS = 200;

function PinPadButton({
  value, children, className, isDisabled, isPasscodeScreen, secondaryLabel, ariaLabel, onClick,
}: OwnProps) {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    vibrate();
    onClick?.(value);
    if (isPasscodeScreen) return;
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, CLICKED_TIMEOUT_MS);
  };
  if (isPasscodeScreen) {
    return (
      <button
        type="button"
        className={buildClassName(styles.button, className)}
        disabled={isDisabled}
        aria-label={ariaLabel ?? String(value)}
        title={ariaLabel}
        onClick={!isDisabled ? handleClick : undefined}
      >
        {value !== undefined ? (
          <>
            <span className={styles.number}>{value}</span>
            <span className={styles.letters} aria-hidden>{secondaryLabel || '\u00a0'}</span>
          </>
        ) : children}
      </button>
    );
  }
  return (
    <div
      onMouseDown={!isDisabled ? handleClick : undefined}
      className={buildClassName(styles.button, isClicked && styles.buttonActive, className)}
      role="button"
      tabIndex={0}
    >
      {value || children}
    </div>
  );
}

export default memo(PinPadButton);
